import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'raw-body-description',
  templateUrl: './raw-body-description.component.html',
  styleUrls: ['./raw-body-description.component.scss']
})
export class RawBodyDescriptionComponent implements OnInit {

  @Input() parameters: any;
  @Input() title: any;
  @Input() allParamRequired = false;
  @Input() isTypeFormData = false;
  @Input() hasFixedInputType = false;
  @Input() inputType = 'string';
  @Input() apiType: string;
  @Input() showRequiredDes = true;
  hasValues = false;

  constructor() { }

  ngOnInit(): void {
    if (this.parameters) {
      this.hasValues = this.parameters.some(obj => obj.key !== '');
      if (this.allParamRequired) {
        for (const val of this.parameters) {
          val['req'] = true;
        }
      }
    }
  }

  hasRequiredParams(): boolean {
    return this.showRequiredDes && this.parameters && this.parameters.some(param => param.req === true);
  }

  saveDescription(param: any, value: string) {
    param.description = value;
  }
}
